__turbopack_context__.v({
  "Arrow": "index-module___NYL4q__Arrow",
  "Content": "index-module___NYL4q__Content",
  "GuidesContent": "index-module___NYL4q__GuidesContent",
  "GuidesPanel": "index-module___NYL4q__GuidesPanel",
  "Icon": "index-module___NYL4q__Icon",
  "LinkCard": "index-module___NYL4q__LinkCard",
  "LinkDescription": "index-module___NYL4q__LinkDescription",
  "LinkList": "index-module___NYL4q__LinkList",
  "LinkTitle": "index-module___NYL4q__LinkTitle",
  "List": "index-module___NYL4q__List",
  "Popup": "index-module___NYL4q__Popup",
  "Positioner": "index-module___NYL4q__Positioner",
  "ProductContent": "index-module___NYL4q__ProductContent",
  "Root": "index-module___NYL4q__Root",
  "SubmenuContent": "index-module___NYL4q__SubmenuContent",
  "SubmenuDescription": "index-module___NYL4q__SubmenuDescription",
  "SubmenuHint": "index-module___NYL4q__SubmenuHint",
  "SubmenuLabel": "index-module___NYL4q__SubmenuLabel",
  "SubmenuLayout": "index-module___NYL4q__SubmenuLayout",
  "SubmenuList": "index-module___NYL4q__SubmenuList",
  "SubmenuRoot": "index-module___NYL4q__SubmenuRoot",
  "SubmenuTitle": "index-module___NYL4q__SubmenuTitle",
  "SubmenuTrigger": "index-module___NYL4q__SubmenuTrigger",
  "SubmenuViewport": "index-module___NYL4q__SubmenuViewport",
  "Trigger": "index-module___NYL4q__Trigger",
  "Viewport": "index-module___NYL4q__Viewport",
});
